import React from "react";

export function Badge({ color, children }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "3px 8px",
        borderRadius: 999,
        fontSize: 10,
        fontWeight: 800,
        background: color,
        color: "#FFF",
      }}
    >
      {children}
    </span>
  );
}
